import { UdtError, UdtErrorCode } from './error';

describe('UdtError', () => {
    it('serializes correctly', () => {
        expect(new UdtError(UdtErrorCode.VcSchemaAnnotationMissing, 'Specific error message').message).toEqual(
            'Specific error message\nFor more information about this error, check https://docs.truvity.com/sdk/reference/error-codes#T001',
        );
    });

    it('contains error code', () => {
        expect(new UdtError(UdtErrorCode.VcSchemaAnnotationMissing, 'Specific error message')).toMatchObject({
            code: UdtErrorCode.VcSchemaAnnotationMissing,
        });
    });
});
